import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";

import Modal from "react-modal";
const VansaleGoodIssueForm = (props) => {
  const frmRef = useRef({});

  const [loading, setLoading] = useState(false);

  const [employeelist, setEmployeelist] = useState(null);
  const [salesExecutiveId, setSalesExecutiveId] = useState();
  const [productRequestData, setProductRequestData] = useState();
  const [productRequestId, setProductRequestId] = useState(0);
  const [productRequestDetails, setProductRequestDetails] = useState([]);

  const [productInfo, setProductInfo] = useState();

  const [vehiclelist, setVehiclelist] = useState(null);
  const [vmerId, setvmerId] = useState();
  const [warehouseId, setWarehouseId] = useState(0);

  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px", // Adjust the width as needed
      height: "80%",
      minHeight: "500px",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  var d = new Date();
  var dateString =
    d.getDate() +
    "/" +
    (d.getMonth() + 1) +
    "/" +
    d.getFullYear() +
    " " +
    d.getHours() +
    ":" +
    d.getMinutes() +
    ":" +
    d.getSeconds();

  const { sendRequest: postVanSaleGoodIssue } = useHttp();

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const currentDate = new Date().toISOString().slice(0, 10);

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  function getCurrentTime() {
    const now = new Date();
    let hours = now.getHours();
    let minutes = now.getMinutes();

    // Format hours and minutes with leading zeros if necessary
    hours = hours.toString().padStart(2, "0");
    minutes = minutes.toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  }

  const { sendRequest: getEmp } = useHttp();
  useEffect(() => {
    getEmp(
      {
        url: `/api/employeeByUsecase/?orgId=${localStorage.getItem(
          "orgId"
        )}&useCase=Sales`,
      },
      (data) => {
        setEmployeelist(data.output);
      }
    );
  }, [getEmp]);

  const { sendRequest: getVehicle } = useHttp();
  useEffect(() => {
    getVehicle(
      {
        url: "/api/vehicleMachineEquipRegistratn/",
      },
      (res) => {
        if (res) {
          var vehicle = res.filter((x) => x.vmeClassific == "Vehicle");

          setVehiclelist(vehicle);
        }
      }
    );
  }, [getEmp]);

  const LoadVehicleData = (id) => {
    var itemlist = vehiclelist.filter((item) => item.vmerId == id);
    var selectedItem = itemlist[0];

    frmRef.current.driverName.value = itemlist[0].assignedPersonDriverName;
    frmRef.current.driverContactNo.value = itemlist[0].assignedPersonContactNo;
  };

  const { sendRequest: getProductRequest } = useHttp();

  useEffect(() => {
    getProductRequest(
      {
        url: `/api/productRequest/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setProductRequestData(res);
          //console.log(res);
        }
      }
    );
  }, []);

  const handleRequestChange = (e) => {
    setProductRequestId(e.target.value);
  };

  useEffect(() => {
    getProductRequest(
      {
        url: `/api/productRequest/?orgId=${localStorage.getItem(
          "orgId"
        )}&productRequestId=${productRequestId}`,
      },
      (res) => {
        // //console.log(res);
        if (res) {
          const updatedProductRequestDetails = res.productRequestDetails.map(
            (item) => ({
              ...item,
              itemQuantity: 0,
            })
          );

          const updatedRes = {
            ...res,
            productRequestDetails: updatedProductRequestDetails,
          };

          // //console.log(updatedRes);
          setProductRequestDetails(updatedRes);
          setWarehouseId(res && res.warehouseId);
        }
      }
    );
  }, [productRequestId]);

  const { sendRequest: getProduct } = useHttp();

  const handleProductAdd = (e, data) => {
    setIsModalOpen(true);
    // //console.log(data);
    if (data) {
      const productId = data && data.productId;
      setProductInfo(data);

      getProduct(
        {
          url: `/api/getStockBatchNowise/?warehouseId=${warehouseId}&productId=${productId}`,
        },
        (res) => {
          //console.log(res);

          setProductDetails(res);
        }
      );
    }
  };

  const handleIssuedQuantityChange = (e, index) => {
    const newValue = parseFloat(e.target.value) || 0; // Parse the input value as a float
    const maxQuantity = parseFloat(productDetails[index].productQuantityBal);

    if (newValue > maxQuantity) {
      toast.error("Issued Quantity cannot exceed Available Quantity.");

      newValue = maxQuantity;
    }
    setProductDetails((prevProductDetails) =>
      prevProductDetails.map((item, i) =>
        i === index ? { ...item, issuedQuantity: newValue } : item
      )
    );
  };

  const calculateTotalIssuedQuantity = () => {
    const totalIssuedQuantities = {};

    productDetails.forEach((item) => {
      const productId = item.productId;
      const issuedQuantity = parseFloat(item.issuedQuantity) || 0;

      if (productId in totalIssuedQuantities) {
        totalIssuedQuantities[productId] += issuedQuantity;
      } else {
        totalIssuedQuantities[productId] = issuedQuantity;
      }
    });

    return totalIssuedQuantities;
  };

  const totalIssuedQuantities = calculateTotalIssuedQuantity();

  useEffect(() => {
    const totalIssuedQuantities = calculateTotalIssuedQuantity();

    // Update productRequestDetails with the new Issued Quantities
    const updatedProductRequestDetails =
      productRequestDetails.productRequestDetails &&
      productRequestDetails.productRequestDetails.map((item) => {
        const productId = item.productId;
        const totalIssuedQuantity = totalIssuedQuantities[productId] || 0;

        return {
          ...item,
          itemQuantity: totalIssuedQuantity,
        };
      });

    //console.log(updatedProductRequestDetails);

    setProductRequestDetails({
      ...productRequestDetails,
      productRequestDetails: updatedProductRequestDetails,
    });
  }, [productDetails]);

  const submitHandler = (e) => {
    e.preventDefault();
    setLoading(true);

    const convertedJSON = {
      productDetails:
        productRequestDetails &&
        productRequestDetails.productRequestDetails.map((detail, index) => ({
          srno: index + 1,
          productId: detail.productId.toString(),
          itemId: detail.itemId,
          productName: detail.productName,
          productSubType: detail.productSubType,
          productType: detail.productTypeName,
          availableQuantity: detail.quantity.toString(),
          unit: detail.unitAbbreviation,
          unitId: detail.unitId,
          availableAmount1: 0,
          itemQuantity: detail.itemQuantity.toString(),
          itemQuantityBal: detail.itemQuantity.toString(),
          productCost: 0,
          remark: "",
          status: detail.status,
          createdBy: parseInt(localStorage.getItem("id")),
          orgId: parseInt(localStorage.getItem("orgId")),
          isSave: true,
          goodsTransferProductTrans: [
            {
              productId: detail.productId,
              stockId: null,
              itemQuantity: detail.itemQuantity,
              itemQuantityBal: detail.itemQuantity,
              unitId: detail.unitId,
              productCost: 0,
              orgId: parseInt(localStorage.getItem("orgId")),
            },
          ],
        })),
    };

    // //console.log(convertedJSON.productDetails);

    const input = {
      goodsTransferDate: moment(frmRef.current.date.value).format("DD/MM/YYYY"),
      goodsTransferToOfficerEmpId: salesExecutiveId,
      timeStamp: frmRef.current.time_stamp.value,
      productRequestId: productRequestId,
      productDetails: convertedJSON && convertedJSON.productDetails,
      goodsTransferType: "Van Sales",
      goodsTransferFromWarehouseId: localStorage.getItem("warehouseId"),
      vehicleId: vmerId,
      driverName: frmRef.current.driverName.value,
      driverContactNo: frmRef.current.driverContactNo.value,
      startMeterReading: frmRef.current.startMeterReading.value,
      endMeterReading: frmRef.current.endMeterReading.value,
      remark: frmRef.current.remark.value,
      status: 1,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      serviceId: props.sId,
    };

    postVanSaleGoodIssue(
      {
        url: "/api/goodsTransferVanSales/",
        method: props.update ? "PUT" : "POST",
        body: input,
      },
      (data) => {
        //console.log(data);
        toast.success(
          `Goods transfer For Van Sales ${props.update ? "updated" : "added!"}`
        );
        props.addForm(false);
        setLoading(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Van Sales-Good Issue Details</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"date"}>{"Date "}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"time_stamp"}>{"TimeStamp"}</label>
                      <input
                        type={"time"}
                        id={"time_stamp"}
                        required
                        ref={(el) => (frmRef.current["time_stamp"] = el)}
                        className="form-control"
                        defaultValue={getCurrentTime()}
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"salesExecutive"}>
                        {"Sales Executive"}
                      </label>
                      <select
                        id="salesExecutive"
                        className="form-control"
                        required
                        ref={(el) => (frmRef.current["salesExecutive"] = el)}
                        value={salesExecutiveId}
                        onChange={(e) => {
                          setSalesExecutiveId(e.target.value);
                        }}
                      >
                        <option value="">Select</option>
                        {employeelist &&
                          employeelist.map((x) => (
                            <option
                              key={x.empId}
                              employee-id={x.empId}
                              value={x.empId}
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"productRequest"}>
                        {"Product Request"}
                      </label>
                      <select
                        id="productRequest"
                        className="form-control"
                        required
                        ref={(el) => (frmRef.current["productRequest"] = el)}
                        value={productRequestId}
                        onChange={(e) => handleRequestChange(e)}
                      >
                        <option value="">Select</option>
                        {productRequestData &&
                          productRequestData.map((x) => (
                            <option
                              key={x.productRequestId}
                              value={x.productRequestId}
                            >
                              {x.productRequestNo}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>

                  <div className="row">&nbsp;</div>
                  <div className="row">
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr className="tableheaderrowview">
                          <th>Sr No</th>
                          <th>Item Id</th>
                          <th>Product Name</th>
                          <th>Required Quantity</th>
                          <th>Unit</th>
                          <th>Item Quantity</th>

                          <th>Add</th>
                        </tr>
                      </thead>
                      <tbody>
                        {productRequestDetails.productRequestDetails &&
                          productRequestDetails.productRequestDetails.map(
                            (itm, i) => {
                              return (
                                <tr key={i} className="tablerowview">
                                  <td>{i + 1}</td>
                                  <td>{itm.productId}</td>
                                  <td>{itm.productName}</td>
                                  <td>{itm.quantity}</td>
                                  <td>{itm.unitAbbreviation}</td>
                                  <td>{itm.itemQuantity || 0}</td>
                                  <td>
                                    <button
                                      type="button"
                                      className="btn  btn-success btn-sm mx-2 my-2"
                                      onClick={(e) => handleProductAdd(e, itm)}
                                    >
                                      Add
                                    </button>
                                  </td>
                                </tr>
                              );
                            }
                          )}
                      </tbody>
                    </table>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"vehicle_id"}>{"Vehicle id"}</label>
                      <select
                        id="vmerId"
                        required
                        className="form-control"
                        ref={(el) => (frmRef.current["vmerId"] = el)}
                        value={vmerId}
                        onChange={(e) => {
                          setvmerId(e.target.value);
                          LoadVehicleData(e.target.value);
                        }}
                      >
                        <option value="">Select</option>
                        {vehiclelist &&
                          vehiclelist.map((x) => (
                            <option
                              key={x.vmerId}
                              vmer-id={x.vmerId}
                              value={x.vmerId}
                            >
                              {x.vmeNo}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"driverName"}>{"Driver Name"}</label>
                      <input
                        type={"text"}
                        id={"driverName"}
                        required
                        ref={(el) => (frmRef.current["driverName"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"driverContactNo"}>
                        {"Vehicle Driver Contact Number"}
                      </label>
                      <input
                        type={"text"}
                        id={"driverContactNo"}
                        required
                        ref={(el) => (frmRef.current["driverContactNo"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"startMeterReading"}>
                        {"Start Meter Reading"}
                      </label>
                      <input
                        type={"text"}
                        id={"startMeterReading"}
                        required
                        ref={(el) => (frmRef.current["startMeterReading"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"endMeterReading"}>
                        {"End Meter Reading"}
                      </label>
                      <input
                        type={"text"}
                        id={"endMeterReading"}
                        required
                        ref={(el) => (frmRef.current["endMeterReading"] = el)}
                        className="form-control"
                      />{" "}
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Submit"}
                      </button>
                    </div>
                    <div className="col-md-1">
                      {/* <button className="btn  btn-primary mx-2 my-2" type="submit">
                Cancel
              </button> */}
                    </div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>

      <Modal isOpen={isModalOpen} style={customModalStyles}>
        <div>
          <div className="">
            <div className="">
              <h3 className="card-title">Product Details</h3>
              <div className="card-tools text-right">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="remove"
                  onClick={() => closeModal(false)}
                >
                  <i className="fas fa-times" />
                </button>
                <hr />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-2">
              {" "}
              <label> Product Type </label>
            </div>
            <div className="col-md-1">
              <label> : </label>{" "}
            </div>
            <div className="col-md-3">
              {" "}
              <label>{productInfo && productInfo.productTypeName} </label>{" "}
            </div>
            <div className="col-md-2">
              <label> Product Subtype</label>{" "}
            </div>
            <div className="col-md-1">
              {" "}
              <label> : </label>
            </div>
            <div className="col-md-3">
              {" "}
              <label>
                {" "}
                {productInfo && productInfo.productSubTypeName}{" "}
              </label>{" "}
            </div>
          </div>

          <div className="row">
            <div className="col-md-2">
              {" "}
              <label> Product Name </label>
            </div>
            <div className="col-md-1">
              <label> : </label>{" "}
            </div>
            <div className="col-md-3">
              {" "}
              <label>{productInfo && productInfo.productName} </label>{" "}
            </div>
            <div className="col-md-2">
              <label> Product Code</label>{" "}
            </div>
            <div className="col-md-1">
              {" "}
              <label> : </label>
            </div>
            <div className="col-md-3">
              {" "}
              <label> {productInfo && productInfo.itemId} </label>{" "}
            </div>
          </div>

          <div className="row">
            <div className="col-md-2">
              {" "}
              <label> Required Quantity</label>
            </div>
            <div className="col-md-1">
              <label> : </label>{" "}
            </div>
            <div className="col-md-3">
              {" "}
              <label>
                {" "}
                {productInfo && productInfo.quantity} &nbsp;{" "}
                {productInfo && productInfo.unitAbbreviation}
              </label>{" "}
            </div>
            <div className="col-md-2">
              <label></label>{" "}
            </div>
            <div className="col-md-1">
              {" "}
              <label> </label>
            </div>
            <div className="col-md-3">
              {" "}
              <label> </label>{" "}
            </div>
          </div>

          <div className="">
            <table className="table table-bordered text-center">
              <thead>
                <th>Sr. No</th>
                <th>Lot No</th>
                <th>Batch No</th>
                <th>Available Quantity</th>
                <th>Unit</th>

                <th>Issued Quantity</th>
              </thead>

              <tbody>
                {productDetails &&
                  productDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>

                        <td>{itm.lotNo}</td>
                        <td>{itm.batchNo}</td>
                        <td>{itm.productQuantityBal}</td>
                        <td>{itm.unitName}</td>
                        <td>
                          <input
                            type="textbox"
                            className="inputs-prod-edit"
                            value={itm.issuedQuantity || ""}
                            onChange={(e) => handleIssuedQuantityChange(e, i)}
                          />
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>

          <div className="row">
            <div className="col-md-3"></div>
            <div className="col-md-2"></div>

            <div className="col-md-2">
              <button
                className="btn  btn-primary mx-2 my-2"
                onClick={() => {
                  setIsModalOpen(false);

                  // //console.log(productDetails);
                }}
              >
                Save
              </button>
            </div>
            <div className="col-md-3"></div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default VansaleGoodIssueForm;
